/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { css } from "@emotion/core"

export const actionWrapper = css`
  .delete-btn {
    display: flex;
    color: #f55538;
    position: absolute;
    bottom: 10px;
    left: 10px;
    cursor: pointer;
    background: white;
    font-size: 1.2em;
    border-radius: 50%;
    padding: 8px;
  }
  .drag-btn {
    display: flex;
    position: absolute;
    top: 10px;
    left: 90px;
    cursor: pointer;
    background: white;
    font-size: 1.2em;
    border-radius: 50%;
    padding: 8px;
  }
  .pencil-btn {
    display: flex;
    position: absolute;
    bottom: 10px;
    left: 90px;
    cursor: pointer;
    background: white;
    font-size: 1.2em;
    border-radius: 50%;
    padding: 8px;
  }
  .action-wrapper {
    display: none;
  }
  .thumbnail-img:hover ~ .action-wrapper {
    display: block;
  }
  .action-wrapper:hover {
    display: block;
  }
`

export const drawerTitleStyle = css`
  font-size: 16px;
  text-transform: uppercase;
`

export const drawerBodyBackground = css`
  background-color: #f5f5f5;
`

export const drawerBodyStyle = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  ${drawerBodyBackground}
`

export const itemDrawerInfoIconStyle = css`
  color: #898d97ff;
  padding-left: 4px;
  font-size: 16px;
`

export const itemDrawerBodyStyle = css`
  height: 100%;
  display: flex;
  flex-direction: column;

  .section-separator {
    padding: 21px 31px 21px 24px;
    font-weight: 500;
    span {
      font-size: 16px;
    }
    span:nth-of-type(1) {
      text-transform: uppercase;
    }
  }

  .linked-modifier-wrapper {
    .empty-mg-list {
      background: #fff;
      padding: 16px 28px 60px 28px;
    }
    .empty-mg-list p {
      color: #979797;
      font-size: 14px;
    }
  }
`

export const listModifierWrapperStyles = (enabled: boolean) => css`
  ${enabled &&
    css`
      cursor: row-resize;
    `}
  background: #fff;
  display: flex;
  align-items: center;
  padding: 20px 24px;
  .modifier-name {
    color: #2d2d2d;
    flex: 1;
    margin-right: 8px;
  }
  .modifier-rule {
    color: #979797;
  }
`

export const dashStyle = css`
  min-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
`

export const drawerContentSpacingStyle = css`
  padding: 24px;
`

export const drawerContentStyle = css`
  ${drawerContentSpacingStyle}
  background-color: #ffffff;
  .ant-form-item-label {
    text-transform: uppercase;
    width: 100%;
    text-align: left;
  }
  .ant-form-item-label label:after {
    content: "";
  }
`

export const baseDrawerFooterStyle = css`
  width: 100%;
  padding: 16px 24px;
`

export const deleteItemBtn = css`
  width: 100%;
  padding: 16px 24px 0px 24px;
`

export const drawerFooterSpacing = css`
  padding-bottom: 80px;
`
// don't forget to use the spacing above! otherwise the footer would overlap with the content
export const drawerFooterStyle = css`
  ${baseDrawerFooterStyle}
  background-color: #ffffff;
  /* border-top: 1px solid #e8e8e8; */
  z-index: 1;
  box-shadow: 0px -7px 34px rgba(0, 0, 0, 0.08);
`

export const drawerFooter = css`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 9999;
`

export const photoUploadDrawer = css`
  .dui-upload-wrapper .dui-upload-drag .dui-upload-btn {
    outline: none !important;
  }
  .dui-upload-drag-container {
    width: 100%;
    height: 426px;
    display: flex !important;
    justify-content: center;
    align-items: center;
  }
`

export const thumbnailItemPhoto = css`
  position: relative;
  ${actionWrapper}
  .thumbnail-img {
    width: 130px;
    height: 130px;
    border-radius: 8px;
    border: 1px solid #cedad3;
    object-fit: cover;
  }
`

export const addPhotoStyle = css`
  width: 130px;
  height: 130px;
  background: #f5f5f5;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #aeaeae;
  .duxicon {
    font-size: 40px;
  }
  div {
    text-align: center;
  }
  p {
    margin-top: 8px;
    text-transform: uppercase;
  }
`

export const uploadPhotoErrorStyle = css`
  margin-bottom: 20px;
  .dui-alert-description {
    font-size: 13px;
    color: grey;
  }
`
export const uploadPhotoWarningStyle = css`
  margin-bottom: 20px;
  .dui-alert-description {
    font-size: 13px;
    color: grey;
  }
`

export const thumbnailItemPhotoError = css`
  position: relative;
  ${actionWrapper}
  .thumbnail-img {
    width: 130px;
    height: 130px;
    border-radius: 8px;
    border: 2px solid #f55538;
    cursor: pointer;
    object-fit: cover;
  }
  .error-sign {
    position: absolute;
    bottom: 45px;
    left: 45px;
    cursor: pointer;
    font-size: 42px;
    color: #f55538;
  }
`
export const thumbnailItemPhotoWarning = css`
  position: relative;
  ${actionWrapper}
  .thumbnail-img {
    width: 130px;
    height: 130px;
    border-radius: 8px;
    border: 2px solid #cece18;
    cursor: pointer;
    object-fit: cover;
  }
  .warning-sign {
    position: absolute;
    bottom: 45px;
    left: 45px;
    cursor: pointer;
    font-size: 42px;
    color: #cece18;
  }
`

export const listModifierGroup = css`
  padding-bottom: 50px;
  .description {
    width: 370px;
  }
  .description span:nth-of-type(1) {
    font-size: 16px;
    color: #2d2d2d;
  }
  .dui-list-item {
    padding-top: 31px;
    padding-bottom: 27px;
  }
`

export const backdropFilter = css`
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(20px);
  color: #ffffff;
`

export const disabledSoldByWeight = css`
  color: #979797;
`

export const photoList = css`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  overflow-x: scroll;
  scroll-behavior: smooth;
  max-width: 100%;
  z-index: 1001;

  > div {
    margin-left: 2px;
    margin-right: 2px;
  }

  &::-webkit-scrollbar {
    height: 0px;
    width: 10px;
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.25);
  }
`

export const leftScrollBtn = css`
  top: 42px;
  width: 46px;
  height: 46px;
  min-width: 46px;
  position: absolute;
  left: 0;
  z-index: 9999;
  margin-left: -21px;
  background: #1a1a1a;
  opacity: 0.5;
`

export const rightScrollBtn = css`
  top: 42px;
  width: 46px;
  height: 46px;
  min-width: 46px;
  position: absolute;
  right: 0;
  z-index: 9999;
  margin-right: -21px;
  background: #1a1a1a;
  opacity: 0.5;
`

export const scrollContainer = css`
  display: flex;
  flex-direction: row;
  position: relative;
  height: 162px;
  width: 402px;
  max-width: 402px;
`

export const listSuggestedCategory = css`
  background-color: white;
  .dui-radio-wrapper {
    width: 450px;
    margin: 24px 0;
    padding: 0 24px;

    span:nth-of-type(2) {
      width: 100%;
    }
  }
  .department {
    font-size: 12px;
  }
`

export const listAllGrabCategory = css`
  background-color: white;
  padding-bottom: 61px;
  .dui-list-item {
    margin-bottom: 24px;
    padding: 0 24px;
    border-block-end: unset !important;
    cursor: pointer;
  }
  .department-name-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .anticon-chevron-right {
    margin-left: 8px;
  }
  .dui-radio-wrapper {
    width: 450px;
    margin: 24px 0;
    padding: 0 24px;

    span:nth-of-type(2) {
      width: 100%;
    }
  }
`

export const listSubCategory = css`
  background-color: white;
  padding-bottom: 61px;
  .dui-radio-wrapper {
    width: 450px;
    margin: 24px 0;
    padding: 0 24px;

    span:nth-of-type(2) {
      width: 100%;
    }
  }
  display: flex;
  justify-content: center;
`

export const departmentTaggingLoading = css({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  ".icon": {
    fontSize: 30,
  },
})

export const drawer = css({
  ".dui-drawer-header": {
    background: "white",
  },
  ".dui-drawer-wrapper-body": {
    background: "#f5f5f5",
  },
})

export const searchWrapper = css({
  display: "flex",
  justifyContent: "center",
  height: 80,
  alignItems: "center",
  backgroundColor: "white",
})

export const titleContent = css({
  fontSize: 16,
  fontWeight: 500,
  height: 70,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  marginLeft: 24,
})

export const buttonInLabel = css`
  float: right;
  transform: translate(0, calc(50% + 5px));
`
